import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const formatAssetsForExport = (assets) => {
  return assets.map((asset) => ({
    "Asset Name": asset.connector?.name || "-",
    "Asset Type": asset.connector?.type || "-",
    Category: asset.connector?.category || "-",
    Owner: asset.owner?.name || "-",
    Criticality: asset.criticality || "-",
    Status: asset.connected ? "Connected" : "Not Connected",
    "Created At": asset.created_at
      ? new Date(asset.created_at).toLocaleDateString()
      : "-",
  }));
};

export const exportAssetsCSV = (assets) => {
  const data = formatAssetsForExport(assets);
  const worksheet = XLSX.utils.json_to_sheet(data);
  const csv = XLSX.utils.sheet_to_csv(worksheet);

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, "assets_export.csv");
};

export const exportAssetsExcel = (assets) => {
  const data = formatAssetsForExport(assets);
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Assets");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

  saveAs(blob, "assets_export.xlsx");
};
